const providerProfitBackdrop     = require('./providerProfit-backdrop')
const providerProfitConfirmation = require('./providerProfit-confirmation')
const providerProfitDialog       = require('./providerProfit-dialog')
const providerProfitDt           = require('./providerProfit-dt')
const providerProfitFullcont     = require('./providerProfit-fullcont')
const providerProfitMenu         = require('./providerProfit-menu')
const providerProfitPage         = require('./providerProfit-page')
const providerProfitSnack        = require('./providerProfit-snack')
const providerProfitFetch        = require('./providerProfit-fetch')
const purchaseFullcont2                  = require('./purchase2/purchase-fullcont')
const mtpurchaseFullcont2                  = require('./purchase2/purchase-fullcont-multitable')

export function start(detail){  //console.log('goku-dt 5>', detail)
         
      obj[detail.elem].start(detail)

}/**/

const obj = {
   
      backdrop:        { start: (detail) =>{  providerProfitBackdrop.start(detail)         }},
      confirmation:    { start: (detail) =>{  providerProfitConfirmation.start(detail)     }},
      dialog:          { start: (detail) =>{  providerProfitDialog.start(detail)           }},
      dt:              { start: (detail) =>{  providerProfitDt. start(detail)              }},
      fullcont:        { start: (detail) =>{  providerProfitFullcont. start(detail)        }},
      menu:            { start: (detail) =>{  providerProfitMenu.start(detail)             }},
      page:            { start: (detail) =>{  providerProfitPage.start(detail)             }},
      snack:           { start: (detail) =>{  providerProfitSnack.start(detail)            }},
      fetch:           { start: (detail) =>{  providerProfitFetch.start(detail)            }},
      purchaseFullcont2:   { start: (detail) =>{  purchaseFullcont2.start(detail)          }},
      mtpurchaseFullcont2:   { start: (detail) =>{  mtpurchaseFullcont2.start(detail)      }},
}